export const locale = {
    lang: 'fr',
    data: {
        'SAMPLE': {
            'HELLO': 'Bonjour monde!'
        }
    }
};



// WEBPACK FOOTER //
// /usr/app/src/app/main/content/sample/i18n/fr.ts